import { inject, Injectable } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { AVAILABLE_LANGUAGES, Languages, UserLanguageLoader } from '@skylab-shared/config';

export type ViewLanguage = {
    label: string,
    icon: string,
    symbol: string,
    country: string,
    value: Languages,
};

@Injectable({ providedIn: 'root' })
export class ViewLanguageService {
    private _languages: ViewLanguage[] = [];
    public selectedLanguage: ViewLanguage;

    private l10n = inject(L10n) as L10nBase;

    public constructor(
    ) {
        this.setViewLanguages();
        this.selectedLanguage = this.viewLanguages.find(elem => elem.value === UserLanguageLoader.language) || this.viewLanguages[0];
    }

    public changeLanguage(newVal: ViewLanguage): void {
        UserLanguageLoader.saveUserLanguageAsync(newVal.value).then(() => {
            window.location.reload();
        });
    }

    public get viewLanguages(): ViewLanguage[] {
        if (this._languages.length === 0) {
            throw new Error(`View languages not yet loaded`);
        }
        return this._languages;
    }

    private setViewLanguages(): void {
        this._languages = AVAILABLE_LANGUAGES.map(language => ({
            label: this.l10n.instant(`view-language.countries.${language}.language`),
            icon: this.l10n.instant(`view-language.countries.${language}.icon`),
            symbol: this.l10n.instant(`view-language.countries.${language}.symbol`),
            country: this.l10n.instant(`view-language.countries.${language}.country`),
            value: language
        }));
    }
}
